function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
import React from 'react';
import { withTheme } from 'styled-components';
import { getPeriod, getFundDisplayName, getProductTypeById, getProductTypeLabel } from '@finect/front-resources/Products';
import { Tabs, TabsPane } from '../../Tabs';
import { Section } from '../../Section';
import { ProductFieldsTable } from '../../Products';
export var FundRatios = function (_React$Component) {
  _inherits(FundRatios, _React$Component);
  var _super = _createSuper(FundRatios);
  function FundRatios() {
    _classCallCheck(this, FundRatios);
    return _super.apply(this, arguments);
  }
  _createClass(FundRatios, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        product = _this$props.product,
        _this$props$bottomMar = _this$props.bottomMargin,
        bottomMargin = _this$props$bottomMar === void 0 ? true : _this$props$bottomMar;
      var periods = ['M12', 'M36', 'M60'];
      var tabs = periods.map(function (period) {
        var tableFields = [{
          id: 'performance',
          period: period,
          withSparkline: false,
          format: 'stat'
        }, {
          id: 'standardDeviation',
          period: period,
          format: 'stat'
        }, {
          id: 'maxDrawdown',
          period: period,
          format: 'stat'
        }, {
          id: 'alpha',
          period: period,
          format: 'stat'
        }, {
          id: 'beta',
          period: period,
          format: 'stat'
        }, {
          id: 'sharpeRatio',
          period: period,
          format: 'stat'
        }, {
          id: 'r2',
          period: period,
          format: 'stat'
        }, {
          id: 'trackingError',
          period: period,
          format: 'stat'
        }, {
          id: 'correlation',
          period: period,
          format: 'stat'
        }, {
          id: 'informationRatio',
          period: period,
          format: 'stat'
        }];
        return {
          period: period,
          title: getPeriod(period).tableLabel,
          tableFields: tableFields
        };
      });
      var productType = getProductTypeById(product.subtype);
      var subtitle = "Principales ratios (en euros) del ".concat(getProductTypeLabel(productType, 'shortSingular', 'lowercase'), " ").concat(getFundDisplayName(product.entity, getProductTypeById(product.subtype)), ":");
      return React.createElement(Section, {
        title: "Ratios",
        subtitle: subtitle,
        bottomMargin: bottomMargin
      }, React.createElement(Tabs, null, tabs.map(function (tab, i) {
        return React.createElement(TabsPane, {
          key: i,
          title: tab.title
        }, React.createElement(ProductFieldsTable, {
          product: product,
          fields: tab.tableFields
        }));
      })));
    }
  }]);
  return FundRatios;
}(React.Component);
export default withTheme(FundRatios);